import { render, staticRenderFns } from "./anComicCoverUpload.vue?vue&type=template&id=4a2dbf74"
import script from "./anComicCoverUpload.vue?vue&type=script&lang=js"
export * from "./anComicCoverUpload.vue?vue&type=script&lang=js"
import style0 from "./anComicCoverUpload.vue?vue&type=style&index=0&id=4a2dbf74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports